import { Component, inject, Input } from '@angular/core';
import { DataLayerService } from '@shared/services/data-layer';
import { GtmEvent } from '@shared/services/data-layer/models';

@Component({ template: '' })
export abstract class AbstractDynamicComponent<T> {
  @Input() data!: T;
  @Input() position!: number;
  @Input() isImageInPreviousBlocks!: boolean;

  private readonly dataLayerService = inject(DataLayerService);

  protected emitGtmEvent(event: Partial<GtmEvent> | Partial<GtmEvent>[]): void {
    const hasNonEmptyEvent = (obj: Partial<GtmEvent>): boolean =>
      typeof obj.event === 'string' && obj.event.trim().length > 0;

    if (Array.isArray(event)) {
      const validItems = event.filter((item) => item && hasNonEmptyEvent(item));
      if (validItems.length > 0) {
        this.dataLayerService.push(validItems);
      }
      return;
    }

    // Single object case
    if (event && hasNonEmptyEvent(event)) {
      this.dataLayerService.push(event);
    }
  }
}
